/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type PdpSharedBlurbShipping_shipment$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpRespSidebarBlurbs_shipment$ref: FragmentReference;
export type PdpRespSidebarBlurbs_shipment = {|
  +$fragmentRefs: PdpSharedBlurbShipping_shipment$ref,
  +$refType: PdpRespSidebarBlurbs_shipment$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PdpRespSidebarBlurbs_shipment",
  "type": "Shipment",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedBlurbShipping_shipment",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '0520c02ebca9269dca1924ae0618c8f7';
module.exports = node;
